var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5971 10.2221C20.5971 9.39992 20.5288 8.79992 20.3811 8.1777H10.7761V11.8888H16.414C16.3004 12.811 15.6866 14.1999 14.3226 15.1332L14.3034 15.2574L17.3404 17.5572L17.5508 17.5777C19.4831 15.8332 20.5971 13.2666 20.5971 10.2221Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.776 20C13.5381 20 15.8569 19.1111 17.5507 17.5778L14.3224 15.1333C13.4586 15.7222 12.2991 16.1333 10.776 16.1333C8.07071 16.1333 5.77462 14.3889 4.95613 11.9778L4.83616 11.9877L1.67832 14.3766L1.63702 14.4889C3.3193 17.7555 6.77484 20 10.776 20Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.95626 11.9779C4.74029 11.3556 4.61531 10.6889 4.61531 10.0001C4.61531 9.31113 4.74029 8.64449 4.9449 8.02228L4.93918 7.88976L1.74177 5.46249L1.63715 5.51113C0.943804 6.86671 0.545959 8.38896 0.545959 10.0001C0.545959 11.6112 0.943804 13.1333 1.63715 14.4889L4.95626 11.9779Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.776 3.86664C12.697 3.86664 13.9928 4.67775 14.7317 5.35557L17.6188 2.6C15.8456 0.988893 13.5381 0 10.776 0C6.77484 0 3.3193 2.24443 1.63702 5.51107L4.94477 8.02221C5.77462 5.61111 8.07071 3.86664 10.776 3.86664Z",
    fill: "#EB4335"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.23acdb623d96bb84a6c80ced577b4ab3.svg";
export { ForwardRef as ReactComponent };